class UFilteredListFilterItem extends Uneet {
  constructor (domElement, toggleCallback) {
    super(domElement)
    this.label = this._e.querySelectorAll('button')[0].innerHTML
    this.isActive = false
    this.__toggleCallback = toggleCallback
    this.__init()
  }

  __init () {
    // bind toggle button
    const toggleBtn = this._e.querySelectorAll('button')[0]
    toggleBtn.onClick((ev) => {
      this.toggle()
    })
  }

  toggle (force = null) {
    const initialIsActive = this.isActive
    if (force === null) {
      this.isActive = !this.isActive
    } else {
      this.isActive = force
    }

    this._e.toggleClass('isActive', this.isActive)

    if (initialIsActive !== this.isActive) {
      this.__toggleCallback(this)
    }
  }
}
